export default __webpack_public_path__ + "static/media/azure.a4419965.svg";